import { formatCurrency, formatNumber } from './formatters'

export function salesTeamGoalsData (input, mode = 'light') {
  var response = {}

  var tradeSeries = {
    name: 'Current Trade',
    type: 'column',
    data: input.map((item) => item.TotalTradeNow),
  }

  var lastYearSeries = {
    name: 'Trade Last Year',
    type: 'line',
    data: input.map((item) => item.TotalTradeLast),
  }

  var goalSeries = {
    name: 'Goal',
    type: 'area',
    data: input.map((item) => item.Goal),
  }

  var labelsData = input.map((item) => item.SalesPerson)

  var chartOptions = {
    chart: {
      toolbar: {
        show: false,
      },
      stacked: false,
    },
    theme: {
      mode: mode,
      palette: 'palette1',
    },
    stroke: {
      width: [0, 2, 2],
      curve: 'smooth',
    },
    plotOptions: {
      bar: {
        columnWidth: '50%',
      },
    },

    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: 'light',
        type: 'vertical',
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100],
      },
    },
    markers: {
      size: [0, 0, 2],
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return formatCurrency(y)
          }
          return y
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const tradeValue = formatCurrency(series[0][dataPointIndex])
        const tradeLabel = w.globals.seriesNames[0]
        const tradeColor = w.globals.colors[0]
        const goalValue = formatCurrency(series[1][dataPointIndex])
        const goalLabel = w.globals.seriesNames[1]
        const goalColor = w.globals.colors[1]
        const tradeLastValue = formatCurrency(series[2][dataPointIndex])
        const tradeLastLabel = w.globals.seriesNames[2]
        const tradeLastColor = w.globals.colors[2]
        const bkcolor = '#1974d1'
        const salesPerson = labelsData[dataPointIndex]
        const chartID = w.globals.chartID
        return threeAxisBarToolTip(
          chartID,
          bkcolor,
          salesPerson,
          tradeLabel,
          tradeValue,
          tradeColor,
          goalLabel,
          goalValue,
          goalColor,
          tradeLastLabel,
          tradeLastValue,
          tradeLastColor)
      },
      },

  }

  chartOptions.labels = labelsData

  response.chartOptions = chartOptions
  response.series = [tradeSeries, goalSeries, lastYearSeries]

  return response
}

export function salesTeamSalesPieData (input, mode = 'light') {
  return {
    series: input.map((item) => item.TotalTradeNow),
    chartOptions: {
      labels: input.map((item) => item.SalesPerson),
      type: 'pie',
      theme: {
        mode: mode,
        palette: 'palette1',
      },
      legend: {
        position: 'right',
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const chartID = w.globals.chartID
          const bkcolor = w.globals.colors[seriesIndex]
          const title = w.config.labels[seriesIndex]
          const totalNumber = formatCurrency(series[seriesIndex])
          const totalNumberLabel = 'Total Trade:'
          const totalPercent = Math.round(w.globals.seriesPercent[seriesIndex] * 10) / 10
          const totalPercentLabel = 'Percent:'
          return pieToolTip(chartID, bkcolor, title, totalNumber, totalNumberLabel, totalPercent, totalPercentLabel)
        },
      },
    },
  }
}

export function salesTradePieData (input, mode = 'light') {
  return {
    series: input.map((item) => item.TotalTradeNow),
    chartOptions: {
      labels: input.map((item) => item.Customer),
      type: 'pie',
      theme: {
        mode: mode,
        palette: 'palette1',
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const chartID = w.globals.chartID
          const bkcolor = w.globals.colors[seriesIndex]
          const title = w.config.labels[seriesIndex]
          const totalNumber = formatCurrency(series[seriesIndex])
          const totalNumberLabel = 'Total Trade:'
          const totalPercent = Math.round(w.globals.seriesPercent[seriesIndex] * 10) / 10
          const totalPercentLabel = 'Percent:'
          return pieToolTip(chartID, bkcolor, title, totalNumber, totalNumberLabel, totalPercent, totalPercentLabel)
        },
      },
    },
  }
}

export function salesMSFPieData (input, mode = 'dark') {
  return {
    series: input.map((item) => item.TotalMSFNow),
    chartOptions: {
      labels: input.map((item) => item.Customer),
      type: 'pie',
      theme: {
        mode: mode,
        palette: 'palette1',
      },
      legend: {
        position: 'left',
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const chartID = w.globals.chartID
          const bkcolor = w.globals.colors[seriesIndex]
          const title = w.config.labels[seriesIndex]
          const totalNumber = formatNumber(series[seriesIndex])
          const totalNumberLabel = 'Total MSF:'
          const totalPercent = Math.round(w.globals.seriesPercent[seriesIndex] * 10) / 10
          const totalPercentLabel = 'Percent:'
          return pieToolTip(chartID, bkcolor, title, totalNumber, totalNumberLabel, totalPercent, totalPercentLabel)
        },
      },
    },
  }
}

function pieToolTip (chartID, bkcolor, title, totalNumber, totalNumberLabel, totalPercent, totalPercentLabel) {
  return `
    <div class="tooltip-${chartID}">
      <div class="header-${chartID}">${title}</div>
      <table>
        <tr>
          <td class="tool-tip-row-${chartID}">
            <div class="circle-${chartID}"/>
          </td>
          <td class="tool-tip-row-${chartID}">
            <span class="tool-tip-label-${chartID}">${totalNumberLabel} </span>
            <span class="tool-tip-value-${chartID}">${totalNumber}</span>
          </td>
        </tr>
        <tr>
          <td class="tool-tip-row-${chartID}">
            <div class="circle-${chartID}"/>
          </td>
          <td class="tool-tip-row-${chartID}">
            <span class="tool-tip-label-${chartID}">${totalPercentLabel} </span>
            <span class="tool-tip-value-${chartID}">${totalPercent}%</span>
          </td>
        </tr>
      </table>
    </div>
    <style>
    .tooltip-${chartID} {
      background-color:#F0F0F0;
    }
    .header-${chartID} {
      background-color: ${bkcolor};
      padding: 5px 10px 10px 10px;
      color:white;
      font-weight: bold;
      text-align: center;
    }
    .tool-tip-row-${chartID} {
      padding-left: 5px;
      padding-right: 5px;
    }
    .tool-tip-label-${chartID} {
      color:gray;
    }
    .tool-tip-value-${chartID} {
      color:${bkcolor};
      font-weight: bolder;
    }
    .circle-${chartID} {
      border-radius: 50%;
      display: inline-block;
      background: ${bkcolor};
      width: 10px;
      height: 10px;
    }
    </style>
  `
}

function threeAxisBarToolTip (chartID, bkcolor, title, axis1Label, axis1Value, axis1Color, axis2Label, axis2Value, axis2Color, axis3Label, axis3Value, axis3Color) {
  return `
    <div class="tooltip-${chartID}">
      <div class="header-${chartID}">${title}</div>
      <table>
        <tr>
          <td class="tool-tip-row-${chartID}">
            <div class="circle1-${chartID}"/>
          </td>
          <td class="tool-tip-row-${chartID}">
            <span class="tool-tip-label-${chartID}">${axis1Label} </span>
            <span class="tool-tip-value-${chartID}">${axis1Value}</span>
          </td>
        </tr>
        <tr>
          <td class="tool-tip-row-${chartID}">
            <div class="circle2-${chartID}"/>
          </td>
          <td class="tool-tip-row-${chartID}">
            <span class="tool-tip-label-${chartID}">${axis2Label} </span>
            <span class="tool-tip-value-${chartID}">${axis2Value}</span>
          </td>
        </tr>
        <tr>
          <td class="tool-tip-row-${chartID}">
            <div class="circle3-${chartID}"/>
          </td>
          <td class="tool-tip-row-${chartID}">
            <span class="tool-tip-label-${chartID}">${axis3Label} </span>
            <span class="tool-tip-value-${chartID}">${axis3Value}</span>
          </td>
        </tr>
      </table>
    </div>
    <style>
    .tooltip-${chartID} {
      background-color:#F0F0F0;
    }
    .header-${chartID} {
      background-color: ${bkcolor};
      padding: 5px 10px 10px 10px;
      color:white;
      font-weight: bold;
      text-align: center;
    }
    .tool-tip-row-${chartID} {
      padding-left: 5px;
      padding-right: 5px;
    }
    .tool-tip-label-${chartID} {
      color:gray;
    }
    .tool-tip-value-${chartID} {
      color:${bkcolor};
      font-weight: bolder;
    }
    .circle1-${chartID} {
      border-radius: 50%;
      display: inline-block;
      background: ${axis1Color};
      width: 10px;
      height: 10px;
    }
    .circle2-${chartID} {
      border-radius: 50%;
      display: inline-block;
      background: ${axis2Color};
      width: 10px;
      height: 10px;
    }
    .circle3-${chartID} {
      border-radius: 50%;
      display: inline-block;
      background: ${axis3Color};
      width: 10px;
      height: 10px;
    }
    </style>
  `
}
